var map = {
	"./jiaowu_mobile1.jpg": "f976",
	"./jiaowu_mobile2.jpg": "5a00",
	"./jiaowu_mobile3.jpg": "0060",
	"./jiaowu_mobile4.jpg": "1b27",
	"./jiaowu_mobile5.jpg": "3516",
	"./jiaowu_mobile6.jpg": "9420"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5537";